import { put, call } from 'redux-saga/effects';

import { initDone } from '../reducers/auth';

import api from '../lib/api';

export function* init() {
  try {
    const { isLoggedIn, roles } = yield call(api.init);

    yield put(initDone({ isLoggedIn: !!isLoggedIn, roles }));
  } catch (ex) {
    console.log('ERROR', ex);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js